var classes = {"container":"index-module_container__BF3kE","dropdown-wrapper":"index-module_dropdown-wrapper__cw00E","open":"index-module_open__-PwkH","dropdown":"index-module_dropdown__8PFfS","dropdown--is-open":"index-module_dropdown--is-open__pSLJB","helptext":"index-module_helptext__TGxtd","newsearch":"index-module_newsearch__akJsw"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
